<template>
  <div class="f-imagesCarousel">
    <h2 class="title-container clickable" @click="loadSignPetition">#AlpFoodwayUNESCO</h2>
    <b-carousel id="carousel1"
                style="text-shadow: 1px 1px 2px #333;"
                controls
                indicators
                background="#ababab"
                :interval="4000"
                img-width="2048"
                img-height="1040"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd">

      <template v-for="(item, index) in carouselImages">
        <b-carousel-slide :key="index"
                          :img-src="imagePath(item)"
                          :img-alt="carouselImages[index]">
          <div :class="[{'imageContent-mobile' : $store.getters.isMobileValue},'imageContent']">
            <transition name="slide-fade-right">
              <div class="title" v-if="hasTransitionEnded">
                <a @click="loadAboutUSModal"><p>
                  {{generateCaption(index)}}</p></a>
              </div>
            </transition>
            <transition name="slide-fade-left">
              <div class="subtitle" v-if="hasTransitionEnded">
                <a @click="loadAboutUSModal"><p>
                  {{generateText(index)}}</p></a>
              </div>
            </transition>
          </div>
        </b-carousel-slide>
      </template>
    </b-carousel>
    <about-us-modal ref="aboutUsModalExt"></about-us-modal>
  </div>
</template>

<script>
  import SignPetitionPage from '../../pagesComponents/signPetitionPageComponents/SignPetitionPage'
  import AboutUsModal from './AboutUsModal'

export default {
    name: 'ImagesCarousel',
    components: {AboutUsModal},
    data () {
      return {
        carouselImages: ['alpfoodway_background1', 'alpfoodway_background2', 'alpfoodway_background3', 'alpfoodway_background4', 'alpfoodway_background5', 'alpfoodway_background6'],
        carouselVideos: ['s8AWxn-_3l0', '41wV7L8WYG0', 'HNyJwLD4kxU', 'h_7KwqL79as', 'n-qOHBF2YW4'],
        slide: 0,
        hasTransitionEnded: false
      }
    },
    methods: {
      loadAboutUSModal () {
        this.$refs.aboutUsModalExt.showModal()
      },
      imagePath (imageName) {
        return require('../../../assets/alpfoodway_carousel/' + imageName + '_resized.jpg')
      },
      getYoutubeLink (videoId) {
        return 'https://www.youtube.com/embed/' + videoId
      },
      loadSignPetition () {
        this.$store.commit('setCurrentView', SignPetitionPage)
        this.$router.push('/sign-petition')
      },
      onSlideStart (slide) {
        this.hasTransitionEnded = false
      },
      onSlideEnd (slide) {
        this.hasTransitionEnded = true
      },
      generateCaption (slideNumber) {
        return this.activeLanguage.carouselTitles[slideNumber]
      },
      generateText (slideNumber) {
        return this.activeLanguage.carouselSubtitles[slideNumber]
      }
    },
    computed: {
      activeLanguage () {
        let currLang = this.$translations[this.$store.getters.currentLanguageValue]
        if (currLang.carouselTitles) {
          return this.$translations[this.$store.getters.currentLanguageValue]
        } else {
          return this.$translations['English']
        }
      }
    },
    mounted () {
      this.hasTransitionEnded = true
    }
  }
</script>

<style scoped>
  .resize-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 60vh;
  }

  /*.title-container{*/
    /*margin-bottom: 1%;*/
  /*}*/

  .imageContent-mobile {
    margin-bottom: 10% !important;
    margin-right: 11% !important;
    font-size: 6pt !important;
    margin-left: -20px !important;
  }

  .youtube-slide {
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    padding: 0;
  }

  .imageContent {
    margin-bottom: 20%;
    margin-right: 25%;
  }

  .title, .subtitle {
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: auto;
    /* padding: 1%; */
    /* background: slateGray; */
    /* color: lavender; */
  }

  .subtitle {
    margin-left: 20%;
    list-style: none;
    width: 100%;
    padding: 0;
    /*white-space: nowrap;*/
    /*overflow-x: auto;*/
    /*overflow-y: hidden;*/
  }

  .title > a > p {
    background-color: rgba(196, 28, 33, .9);
    padding: 1%;
    word-break: keep-all;
    font-size: 2em;
    text-align: center;
    margin-right: 20%;
    display: grid;
  }

  a {
    text-decoration: none;
    color: white;
    cursor: pointer;
  }

  a:hover {
    text-decoration: none;
    color: white;
  }

  .subtitle > a > p {
    background-color: rgba(53, 58, 63, .8);
    padding: 1%;
    word-break: keep-all;
    font-size: 1.5em;
    width: 100%;
    /*display: inline-block;*/
  }

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-right-enter-active, .slide-fade-left-enter-active {
    transition: all .9s ease;
  }

  .slide-fade-right-leave-active, .slide-fade-left-leave-active {
    transition: all .01s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-right-enter, .slide-fade-right-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateX(10px);
    opacity: 0;
  }

  .slide-fade-left-enter, .slide-fade-left-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateX(-10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/ImagesCarousel.vue